import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import SoftBox from 'components/SoftBox';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);



const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
        legend: {
            display: false,
            position: 'top',
        },
        title: {
            display: false
        },
    },
    scales: {
        x: { // For the X-axis
            // display: false,
            type: 'time', // Crucial for time-based x-axis
            time: {
                unit: 'minute' // Adjust the unit as needed (e.g., 'hour', 'month')
            },
            // distribution: 'series', // This is the key setting
            display: false,
            ticks: {
                autoSkip: true, // Optional: Set to false if you want all labels to be displayed
                maxRotation: 0,   // Prevents rotation beyond 0 degrees (horizontal)
                minRotation: 0,    // Prevents rotation below 0 degrees (horizontal)
                maxTicksLimit: 2,
                align: 'start'
            }

        },
        y: { // For the Y-axis
            display: false
        }
    },
    animation: {
        duration: 10
    }

};

export default function MiniBarChart({ data, height, width }) {


    // debugger;

    function getBackgroundColor(c) {
        // console.log(c.raw)
        if (c.raw) {
            if (c.raw.density < 5) {
                return 'rgba(38, 124, 204, 1)'
            }
            else if (c.raw.density < 10) {
                return 'rgb(38, 124, 204)'
            }
            else if (c.raw.density < 15) {
                return 'rgb(131, 180, 226)'
            }
            else if (c.raw.density < 20) {
                return 'rgb(239,128,98)'
            }
            else {
                return 'rgb(255, 24, 24)'
            }
        }

        return 'rgba(38, 124, 204, 0.5)'

    }



    let graph_data = {
        // labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [
            {
                // label: 'My First Dataset',
                data: data,
                backgroundColor: getBackgroundColor,
                borderColor: getBackgroundColor,
                borderWidth: 1,
            },
        ],
    };

    return <Bar data={graph_data} options={options} />

}